export const Server = process.env.REACT_APP_SERVER_URL



